(ns ui.view.card.fees.event
  (:require
   [re-frame.core :as rf]
   [ui.view.card.fees.model :as model]
   [ui.view.card.event :as common-event]
   [oops.core :as oops]
   [potpuri.core :as p]

   [frontend.controller.websocket.event :as ws]
   [ui.cofx.response :as response-cofx]))

(rf/reg-event-fx
 ::refetch-data
 [rf/trim-v]
 (fn [_ [ctx]]
   (let [event (common-event/create-fetch-card-data-event (assoc ctx :reset-entities? true))]
     {:fx [[:dispatch event]]})))

(rf/reg-fx
 ::show-modal
 (fn [modal-id]
   (if-let [el (oops/ocall js/document "getElementById" modal-id)]
     (oops/ocall el "showModal")
     (js/console.error "Modal not found" modal-id))))

(rf/reg-fx
 ::close-modal
 (fn [modal-id]
   (if-let [el (oops/ocall js/document "getElementById" modal-id)]
     (oops/ocall el "close")
     (js/console.error "Modal not found" modal-id))))

(rf/reg-event-fx
 ::open-delete-confirmation-modal
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx} fee-id]]
   {:db (assoc-in db (into card-state-path [:delete-confirmation-entity-id]) fee-id)
    ::show-modal (model/delete-fee-confirmation-modal-id ctx)}))

(rf/reg-event-fx
 ::close-delete-confirmation-modal
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx}]]
   {:db (p/dissoc-in db (into card-state-path [:delete-confirmation-entity-id]))
    ::close-modal (model/delete-fee-confirmation-modal-id ctx)}))

(rf/reg-event-fx
 ::delete-fee-success
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [{:keys [db stale-reponse?]} [{:keys [card-state-path] :as ctx}]]
   (if stale-reponse?
     {::close-modal (model/delete-fee-confirmation-modal-id ctx)}
     {:db (p/dissoc-in db (into card-state-path [:delete-confirmation-entity-id]))
      :fx [[:dispatch [::refetch-data ctx]]
           [:dispatch [::common-event/close-entity-peek ctx]]
           [::close-modal (model/delete-fee-confirmation-modal-id ctx)]]})))

(rf/reg-event-fx
 ::delete-fee-error
 [rf/trim-v
  response-cofx/stale-response?]
 (fn [_cofx [_ctx resp]]
   ;; TODO: Handle error
   (js/console.error "Delete fee failed " resp)))

(rf/reg-event-fx
 ::delete-fee
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx}]]
   (let [fee-id (get-in db (into card-state-path [:delete-confirmation-entity-id]))]
     {::ws/send {:id :entity/disable!
                 :body {:entity-id fee-id}
                 :on-success [::delete-fee-success ctx]
                 :on-error [::delete-fee-error ctx]}})))
